import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  actionButtons: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-between',
    marginTop: '18px'
  },
  utilityWrapper: {
    marginTop: '32px'
  },
  utilityIconWrapper: {
    marginRight: '10px'
  },
  smField: {
    maxWidth: '160px'
  }
});
export default useStyles;